import React from "react";
class PricingContent extends React.Component {
  render() {
    return (
      <section className="section bg-light" id="price">
        <div className="container">
          <div className="row mt-5">
            <div className="col-lg-4">
              <div className="price_box text-center mt-3 p-5">
                <div className="price_name">
                  <h1 className="getbluetitle">USA</h1>
                </div>
                <div style={{ clear: "both", height: "20px" }} />
                <div className="price_name">
                  <h1 className="getredtitle pricing">
                    Rental Hotspot + Data (As low as $3 / day)
                  </h1>
                </div>
                <div className="plan_price pb-3 mt-4 pt-2">
                  <strong className="getmiddle">
                    US Mobile Hotspot Rental - 7 day pass 1 GB / Day Limit
                  </strong>
                  <div style={{ clear: "both" }} />
                  <h1 className="text-custom mb-0 font-weight-normal">$19</h1>
                </div>
                <div className="plan_price pb-3 mt-4 pt-2">
                  <strong className="getmiddle">
                    US Mobile Hotspot Rental - 10 day pass 1 GB / Day Limit
                  </strong>
                  <div style={{ clear: "both" }} />
                  <h1 className="text-custom mb-0 font-weight-normal">$25</h1>
                </div>

                <div className="plan_price pb-3 mt-4 pt-2">
                  <strong className="getmiddle">
                    US Mobile Hotspot Rental - 20 day pass 1 GB / Day Limit
                  </strong>
                  <div style={{ clear: "both" }} />
                  <h1 className="text-custom mb-0 font-weight-normal">$48</h1>
                </div>

                <div className="plan_price pb-3 mt-4 pt-2">
                  <strong className="getmiddle">
                    US Mobile Hotspot Rental - 30 day pass 1 GB / Day Limit
                  </strong>
                  <div style={{ clear: "both" }} />
                  <h1 className="text-custom mb-0 font-weight-normal">$68</h1>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="price_box text-center active mt-3 p-5">
                <div className="price_name">
                  <h1 className="getredtitle">Global</h1>
                </div>
                <div style={{ clear: "both", height: "20px" }} />
                <div className="price_name">
                  <h1 className="getredtitle pricing">
                    Rental Hotspot + Data (As low as $9 / day)
                  </h1>
                </div>

                {/* <div style={{ clear: "both", height: "20px" }} /> */}

                <div className="plan_price pb-3 mt-4 pt-2">
                  <strong className="getmiddle">
                    Global Hotspot Rental - 7 days pass 0.5GB/Day LImit
                  </strong>
                  <div style={{ clear: "both" }} />
                  <h1 className="text-custom mb-0 font-weight-normal">$63</h1>
                </div>
                <div className="plan_price pb-3 mt-4 pt-2">
                  <strong className="getmiddle">
                    Global Hotspot Rental - 10 days pass 0.5GB/Day LImit{" "}
                  </strong>
                  <div style={{ clear: "both" }} />
                  <h1 className="text-custom mb-0 font-weight-normal">$85</h1>
                </div>
                <div className="plan_price pb-3 mt-4 pt-2">
                  <strong className="getmiddle">
                    Global Hotspot Rental - 20 days pass 0.5GB/Day LImit{" "}
                  </strong>
                  <div style={{ clear: "both" }} />
                  <h1 className="text-custom mb-0 font-weight-normal">$160</h1>
                </div>
                <div className="plan_price pb-3 mt-4 pt-2">
                  <strong className="getmiddle">
                    Global Hotspot Rental - 30 days pass 0.5GB/Day LImit{" "}
                  </strong>
                  <div style={{ clear: "both" }} />
                  <h1 className="text-custom mb-0 font-weight-normal">$225</h1>
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="price_box text-center mt-3 p-5">
                <div className="price_name">
                  <h1 className="getbluetitle">USA</h1>
                </div>
                <div style={{ clear: "both", height: "20px" }} />
                <div className="price_name">
                  <h1 className="getredtitle pricing">T Mobile Sim Card</h1>
                </div>

                {/* <div style={{ clear: "both", height: "20px" }} /> */}

                <div className="plan_price pb-3 mt-4 pt-2">
                  <strong className="getmiddle">
                    T-Mobile Prepaid SIM Card Unlimited Talk, Text, and Data for
                    7 days
                  </strong>
                  <div style={{ clear: "both" }} />
                  <h1 className="text-custom mb-0 font-weight-normal">$29</h1>
                </div>
                <div className="plan_price pb-3 mt-4 pt-2">
                  <strong className="getmiddle">
                    T-Mobile Prepaid SIM Card Unlimited Talk, Text, and Data for
                    14 days{" "}
                  </strong>
                  <div style={{ clear: "both" }} />
                  <h1 className="text-custom mb-0 font-weight-normal">
                    $34
                  </h1>
                </div>

                <div className="plan_price pb-3 mt-4 pt-2">
                  <strong className="getmiddle">
                    T-Mobile Prepaid SIM Card Unlimited Talk, Text, and Data for
                    30 days{" "}
                  </strong>
                  <div style={{ clear: "both" }} />
                  <h1 className="text-custom mb-0 font-weight-normal">
                    $49
                  </h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default PricingContent;



// WEBPACK FOOTER //
// ./src/pages/pricing/PricingContent.js